var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPlay = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.494 7.47681L3.894 2.07682C3.708 1.97242 3.4812 1.97482 3.2976 2.08162C3.1128 2.18962 3 2.38642 3 2.60002V13.4C3 13.6136 3.1128 13.8104 3.2976 13.9184C3.3912 13.9724 3.4956 14 3.6 14C3.7008 14 3.8028 13.9748 3.894 13.9232L13.494 8.52321C13.6824 8.41641 13.8 8.21721 13.8 8.00001C13.8 7.78281 13.6824 7.58361 13.494 7.47681Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlay, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/play.ff83f424.svg";
export { ForwardRef as ReactComponent };